<template lang="pug">
  .container-main#container-main
    header.container-header
      .header-logo(@click="mainPage()")
        h1 
          //- span.icon.icon-logo
          span CBRE管家运营后台
      .header-nav-container
        //- Here for header items
        .header-nav-item(v-for="(m, index) in menuList", :key="m.id",
          @click="setMenuIndex(index)", :class="currentMenuIndex === index ? 'nav-selected' : ''") {{ m.title }}
      .header-toolbox.align-right
        .header-help(@click="help()") 操作指引
        el-badge(:value="unreadSysMsgCount",:hidden="unreadSysMsgCount == 0",@click.native='mainPage()').header-bell
          span.icon.icon-notification-w.header-myInfo-icon
        el-dropdown
          .header-myInfo
            .header-myInfo-content {{ systemInfo.login.username }}（{{ systemInfo.role && systemInfo.role.name }}，{{ systemInfo.environment }}）
            span.icon.icon-more.header-myInfo-arrow
          el-dropdown-menu(slot="dropdown")
            el-dropdown-item(@click.native="myInfo") 个人资料
            //- el-dropdown-item(@click.native="help()") 操作指引
            el-dropdown-item(@click.native="exit", divided) 返回首页

    .content-container#content-container

      .menu-container#menu-container(v-if="menuList.length !== 0 && currentMenuIndex !== 0")
        //- Here for menu items
        el-menu(:default-active="defaultActiveItem", @select="menuHandler", router).menu
          el-menu-item(v-for="m in menuList[currentMenuIndex].subMenu", v-if="!m.hasSub", :index="m.index.toString()",
            :route="{path:m.to}", :key="m.id").menu-item {{ m.title }}
          el-submenu(v-else, :index="m.index.toString()").menu-sub
            span.menu-sub-title(slot="title") {{m.title}}
            el-menu-item(v-for="sub in m.subMenu", :index="sub.index.toString()",
              :route="{path:sub.to}", :key="sub.id").menu-item.menu-sub-item {{sub.title}}
      .container-router-view
        slot

    el-dialog(:visible.sync="agree_show", title="《CBRE管家管理后台服务协议》", fullscreen, v-if="systemInfo.agreeProtocol == 0",
      :close-on-press-escape="false",:close-on-click-modal="false",:show-close="false") 
      terms 
      .dialog-footer.align-center(slot="footer") 
        el-button(@click.native="updateAgree",type="primary") 我知道了
</template>

<script>
import terms from '../components/terms.vue';
import { homeUrl } from '../utils/config';
export default {
  data () {
    return {
      agree_show: true,

      defCommunityIds: null,
      commList: [],

      menuList: [],
      menuLoading: false,
      currentMenuIndex: 0,
      currentItemIndex: 0,

      commSync: {
        canOperate: null,
        communityIds: [],
      },
    };
  },
  computed: {
    isLogin () {
      return this.$store.getters.isLogin;
    },
    defaultActiveMenu () {
      const activeMenuIndex = this.$store.getters.activeMenuIndex;
      return activeMenuIndex ? parseInt(activeMenuIndex) : 0;
    },
    defaultActiveItem () {
      const activeItemIndex = this.$store.getters.activeItemIndex;
      return activeItemIndex ? activeItemIndex + '' : '0';
    },
    systemInfo () {
      return this.$store.getters.systemInfo;
    },
    unreadSysMsgCount () {
      return this.$store.getters.unreadSysMsgCount;
    },
  },
  methods: {
    getMenuList () {
      this.menuLoading = true;
      return this.$store.dispatch('GET_MENU_LIST').catch(({ status, message }) => {
        this.menuLoading = false;
        this.$alert(`系统菜单获取失败：${message}`, {
          type: 'error'
        });
      });
    },
    createMenuList (data) {
      this.menuList = data;
      this.currentMenuIndex = this.defaultActiveMenu;

      // Start watching
      this.$store.watch(({ activeMenuIndex }) => {
        if (activeMenuIndex !== null && this.currentMenuIndex !== activeMenuIndex) {
          const index = parseInt(activeMenuIndex);
          this.currentMenuIndex = index;
          this.$store.dispatch('SET_ACTIVE_MENU_INDEX', index);
        }
      });
    },
    menuHandler (val) {
      this.$store.dispatch('SET_ACTIVE_ITEM_INDEX', val);
    },

    mainPage () {
      this.$router.push('/');
    },
    myInfo () {
      this.$router.push('/myInfo');
    },
    changePassword () {
      this.$router.push('/editPassword');
    },
    // logout () {
    //   this.$store.dispatch('LOGOUT');
    // },
    exit () {
      this.$store.dispatch('REMOVE_ACTIVE_MENU_INDEX');
      this.$store.dispatch('LOGOUT');
      console.log('跳转地址', homeUrl)
      location.replace(homeUrl);
      // const { hostname } = location;
      // let target = '';

      // if (hostname.includes('szizai.cbreip.com')) {              // Production
      //   console.log('Production', 'https://portal.cbreip.com/cbreplatform/login.xhtml');
      //   target = 'https://portal.cbreip.com/cbreplatform/login.xhtml';
      // } else if (hostname.includes('s.zizai.test.cbreip.com') || hostname.includes('szizai.test.cbreip.com')) {  // Test
      //   console.log('test', 'https://portal.test.cbreip.com/cbreplatform/index.xhtml');
      //   target = 'https://portal.test.cbreip.com/cbreplatform/index.xhtml';
      // } else if (hostname.includes('localhost')) {              // localhost
      //   target = 'http://localhost:8810';
      // } else if (hostname.includes('192.168.197.27')) {
      //   target = 'http://192.168.197.27:7666/cbreplatform/login.xhtml';
      // } else {
      //   // this.logout();
      //   return;
      // }
      // location.replace(target);
    },
    help () {
      this.$router.push({path: '/guidePreview'});
    },

    updateAgree () {
      return this.$store.dispatch('UPDATE_AGREE').then(() => {
        this.agree_show = false;
      });
    },

    checkCommSync () {
      this.$store.dispatch('CHECK_COMM_SYNC').then(({ canOperate, communityIds }) => {
        this.commSync.canOperate = canOperate;
        this.commSync.communityIds = communityIds.slice();

        if (communityIds.length > 0) {
          localStorage.setItem('commToSync', communityIds.join(','));
          const content = canOperate === 1 ? '您管理的社区资料有变更，请前往处理。' : '您管理的社区资料有变更，请前往查看并通知社区负责人处理。';
          this.$alert(content, '社区资料变更通知', {
            confirmButtonText: canOperate === 1 ? '处理' : '查看',
            showClose: false,
            callback: () => {
              this.$store.dispatch('SET_ACTIVE_MENU_INDEX', 1);
              this.$router.push('/community');
            },
          });
        }
      }).catch(({ status, message }) => {
        if (status !== 30017) {
          this.$alert(`获取社区资料变更状态失败：${message}`, {
            type: 'error'
          });
        }
      });
    },

    setMenuIndex (index) {
      this.currentMenuIndex = index;
      this.$store.dispatch('SET_ACTIVE_MENU_INDEX', index);
      if (index === 0) {
        this.$store.dispatch('SET_ACTIVE_ITEM_INDEX', '10');
        this.$router.push('/');
      } else if (typeof this.menuList[index].subMenu[0] !== 'undefined') {
        this.$store.dispatch('SET_ACTIVE_ITEM_INDEX', this.menuList[index].subMenu[0].index);
        this.$router.push(this.menuList[index].subMenu[0].to);
      }
    },
  },
  components: {
    terms
  },
  mounted () {
    this.$store.watch(({ systemInfo }) => {
      if (systemInfo.communityList.length > 0) {
        this.commList = systemInfo.communityList;
        if (systemInfo.defCommunityIds === '') {
          this.showSetComm();
        } else {
          this.defCommunityIds = parseInt(systemInfo.defCommunityIds);
          this.getMenuList().then((data) => {   // Get Menu
            this.loading = false;
            this.createMenuList(data);
          });

          // this.checkCommSync();
        }
      }
    });
  }
};
</script>

<style lang="less">
@import "../assets/variables";
@import "../assets/icons.less";

.container-main {
  width: 100%;
  height: 100%;
}

.container-header {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  height: 70px;
  width: 100%;
  background: @font-color-green-dark;
  color: @font-color-white;

  h1 {
    display: flex;
    padding: 20px 0;
    font-size: 18px;

    span {
      height: 30px;
      line-height: 30px;
      cursor: default;
    }
  }
}

.header-logo {
  box-sizing: border-box;
  width: 200px;
  padding-left: 20px;
  background: @font-color-green;
}

.header-nav-container {
  flex: 2;
  display: inline-flex;
  align-items: center;
}

.header-nav {
  display: inline-flex;
  height: 100%;
  align-items: center;
}

.header-nav-item {
  box-sizing: border-box;
  display: block;
  width: 96px;
  text-align: center;
  color: @font-color-white;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &.active {
    font-size: 18px;
    color: @font-color-white;
    text-decoration: none;
  }
  &:active,
  &focus {
    color: @font-color-white;
    text-decoration: none;
  }
}

.nav-selected {
  font-size: 18px;
}

.header-toolbox {
  display: inline-flex;
  height: 100%;
  align-items: center;
}

.header-myInfo {
  display: flex;
  align-items: center;
  padding-right: 20px;
  color: #ffffff;
  cursor: pointer;
}
.header-myInfo-icon {
  display: block;
}
.header-myInfo-arrow {
  display: block;
}

.header-bell {
  margin-right: 3em;
  cursor: pointer;

  .el-badge__content {
    top: 15px;
    right: -5px;
    border: none;
  }
}

.header-help {
  font-size: 12px;
  margin-right: 1em;
  cursor: pointer;
}

.content-container {
  display: flex;
  box-sizing: border-box;
  width: auto;
  height: e("calc(100% - 70px)");
  min-width: 800px;
}

.menu-container {
  overflow: auto;

  width: 200px;
  min-width: 200px;
  background: @font-color-black;

  a {
    text-decoration: none;
  }
  h1 {
    display: flex;
    padding: 20px 0;
    font-size: 18px;

    span {
      height: 30px;
      line-height: 30px;
    }
  }
  .menu {
    border-right: 0;
  }
  .menu-header {
    height: 70px;
    background: @font-color-green;
  }

  .menu-item {
    height: 50px;
    line-height: 50px;

    font-size: @font-size-normal;
    color: @font-color-menu-item;
    background: @font-color-black;

    border-top: 1px solid #434a5c;

    &:hover {
      color: #ffffff;
      background: @font-color-green;
    }

    &:last-child {
      border-bottom: 1px solid #434a5c;
    }
  }

  .menu-sub {
    border-top: 1px solid #434a5c;

    .menu-sub-title {
      color: @font-color-menu-item;
    }

    &:hover .menu-sub-title {
      color: #ffffff;
    }

    &:last-child {
      border-bottom: 1px solid #434a5c;
    }
  }

  .menu-sub-item {
    background: #1b2131;
    border: none;
    list-style-type: disc;
    list-style-position: inside;
  }

  .active .menu-item {
    color: #ffffff;
    background: @font-color-green;
  }
  .is-active {
    color: #ffffff;
    background: @font-color-green;
  }
}
.container-router-view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/container-main.vue